import type { Reactive } from 'vue';
import type { ListingPageContext } from '#layers/block-engine/public';
import { reactiveComputed } from '@vueuse/core';
import { blockContextIsListingPage, useBlockContext } from '#layers/block-engine/public';

export function useListingPageContext(): Reactive<ListingPageContext & { isListingPage: boolean }> {
	const { getRootContext } = useBlockContext();

	return reactiveComputed(() => {
		const rootContext = getRootContext();
		return {
			...rootContext as ListingPageContext,
			isListingPage: blockContextIsListingPage({ getRootContext }),
		};
	});
}
